/* global React, Card, Button, Icon, t */
function BackendStartupError({ backend }) {
  const hostname = String(window.location?.hostname || '').toLowerCase();
  const isLocal = ['localhost', '127.0.0.1', '0.0.0.0'].includes(hostname);
  const useEmulators = () => {
    try { localStorage.removeItem('plumme.devBackend'); } catch (error) {}
    const target = new URL(window.location.origin + window.location.pathname + window.location.hash);
    target.searchParams.set('backend', 'default');
    window.location.replace(target.toString());
  };
  return <div className="app" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
    <Card style={{ width: 'min(560px, 100%)' }}>
      <div className="row gap-14" style={{ alignItems: 'center' }}>
        <span className="icon-chip"><Icon name="alertTri" size={19}/></span>
        <div>
          <h1 className="t-h2">{t('svc.bootErrorTitle', 'Innlastingen stoppet')}</h1>
          <div className="t-sm muted">{t('svc.bootErrorText', 'Plumme fikk ikke fullført oppstarten i denne nettleseren.')}</div>
        </div>
      </div>
      <div className="alert alert-warning mt-16"><span className="alert-ico"><Icon name="alertTri" size={18}/></span><span>{backend.error}</span></div>
      <div className="row gap-10 mt-16" style={{ flexWrap: 'wrap' }}>
        <Button icon="refresh" onClick={() => window.location.reload()}>{t('svc.reload', 'Last inn på nytt')}</Button>
        {isLocal && <Button variant="secondary" icon="database" onClick={useEmulators}>{t('svc.useDefaultBackend', 'Bruk vanlig backend')}</Button>}
        {backend.user && <Button variant="secondary" onClick={() => window.PlummeBackend?.signOut?.()}>{t('app.nobusiness.signOut')}</Button>}
      </div>
    </Card>
  </div>;
}

Object.assign(window, { BackendStartupError });
